module.exports = [
  'v2.3.3', // adyen ipad兼容性问题
  'v2.3.2', // geo一期
  'v2.3.1', // 3.1.3.1需求 - 修复bug
  'v2.3.0', // 3.1.3.0需求 - https://centurygames.feishu.cn/wiki/RwphwhxKDi1QonkDqAfcztBOn7d?fromScene=spaceOverview
  'v2.2.0', // 任务需求迭代 https://centurygames.feishu.cn/wiki/P1YIwbwUwiqxyCkcJTLckWoqnid
  'v2.1.3', // 修复 paypay展示和文案大小展示
  'v2.1.2', // 修复 无法展示钻石的问题
  'v2.1.1', // 修复 googlepay/applepay 支付时无法正常弹起失败弹窗问题
  'v2.1.0', // 3.0.1.0需求 - https://centurygames.feishu.cn/wiki/AO8fwZxfQiWIcAk0gHDcSHNtnBb?fromScene=spaceOverview + 3.0.2.0 需求 - https://centurygames.feishu.cn/wiki/X1yHwhuZ1iE9OWkH49zcC12qnxc?fromScene=spaceOverview
  'v1.9.2', // SEO优化 - GOF_RU|GOT|DA|HSH|TT|HOME
  'v1.9.1', // 0325敏捷版本
  'v1.9.0.1', // GOF / SEO优化
  'v1.9.0', // webshop9期
  'v1.8.4', // 敏捷版本 - https://centurygames.feishu.cn/wiki/DGB3wioisiG5NdkHevuctCSSnrb
  'v1.8.3', // primer 已存卡支付流程优化 - 线性返回后再进行下一步支付 flow
  'v1.8.2', // ru 环境屏蔽 airwallex 和 primer
  'v1.8.1', // 安全升级 - 验签加密
  'v1.7.5', // tga 时区偏移量给用配置 - ru 3, global 0
  'v1.7.4', // 敏捷版本 - https://centurygames.feishu.cn/wiki/DUaHwfSHiiUnwskRbL7cAqEvnkg?fromScene=spaceOverview
  'v1.7.3', // 敏捷版本 - https://centurygames.feishu.cn/wiki/AVdXwDQdDi1UIukhCUJcjatmntc?fromScene=spaceOverview
  'v1.7.2', // 敏捷版本 - 收据邮箱按浏览器+role_id 储存
  'v1.7.1', // 敏捷版本 - https://centurygames.feishu.cn/wiki/SQK7w3CqniegcHk99FBcAr6snDc?fromScene=spaceOverview
  'v1.7.0', // 7期 - https://centurygames.feishu.cn/wiki/DcfvwjEtMiBLzXkywKHcGIJSnth?fromScene=spaceOverview
  'v1.6.0', // 6期 - https://centurygames.feishu.cn/wiki/PzXDwK92kiSgopk5xvXchO8fnD7?fromScene=spaceOverview
  'v1.5.3', // 版本 - 更新 Primer 版本
  'v1.5.2', // 临时版本 - 维护公告倒计时不展示问题修复
  'v1.5.1', // 敏捷版本 - https://centurygames.feishu.cn/wiki/WFGlwFcp6ir4U5k65mvcZxlsnch?fromScene=spaceOverview
  'v1.5.0', // 5期 UI改版 - https://centurygames.feishu.cn/wiki/HagowkR5oinmvNkPM7JcICjanof
  'v1.4.0', // https://centurygames.feishu.cn/wiki/GeNmwO0Kii3as4kNdRUcBJHhn0c
]
